export default "__VITE_ASSET__pTOyuz_1__"